import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { PDFViewer } from '@react-pdf/renderer';

import PDF from '../funtComponents/pdfComponent';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function CustomizedDialogs({ pdfContent, anexos, fechaIni, fechaFin ,openpop, handleClose }) {
  const aliniar = (a, b) =>{
        
    if (a.chan1 > b.chan1) {
      return 1;
    }
    if (a.chan1 < b.chan1) {
      return -1;
    }
    // a must be equal to b
    return 0;
}

pdfContent = Object.values(pdfContent).sort(aliniar)
const sinCosto = pdfContent.flatMap((item) =>{

  if(parseFloat(item.cost) > 0 ){ 
    return item
  }else{ return []}

})

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openpop}
      >
        <PDFViewer style={{width: 550, height: 1600}}>
          <PDF pdfContent={sinCosto} anexos={anexos} fechaIni={fechaIni} fechaFin={fechaFin} />
        </PDFViewer>

      </BootstrapDialog>
    </div>
  );
}
